/* Night Shift FM · core (state, sound, clock, HUD, world loader) + acts 0–3.
   nsfm-shop.js adds the desk, bill, guide, dock, lab, kids' hour and sunrise on top of window.NSFM. */
(function () {
  'use strict';
  var root = document.querySelector('[data-nsfm]');
  if (!root || root.dataset.init) return;
  root.dataset.init = '1';

  var D = {};
  try { D = JSON.parse(root.querySelector('[data-nsfm-data]').textContent); } catch (e) { console.warn('[nsfm] data', e); }
  D.products = D.products || {};
  var mq = function (q) { return !!(window.matchMedia && window.matchMedia(q).matches); };
  var RM = mq('(prefers-reduced-motion: reduce)');
  var PHONE = mq('(max-width: 749px)');
  var COARSE = mq('(pointer: coarse)');
  var LITE = PHONE || (navigator.hardwareConcurrency || 8) <= 4 || (navigator.deviceMemory || 8) <= 3;
  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var pad2 = function (n) { return (n < 10 ? '0' : '') + n; };
  var rnd = function (a) { return a[Math.floor(Math.random() * a.length)]; };
  var smoothstep = function (t) { t = clamp(t, 0, 1); return t * t * (3 - 2 * t); };
  function deck(arr) { var a = arr.slice(), i = a.length; return function () { if (!i) { a.sort(function () { return Math.random() - 0.5; }); i = a.length; } return a[--i]; }; }

  var VILLAINS = {
    sid: { name: 'Sticky Sid', short: 'Sid', color: '#8CE65A', freq: '88.1', show: "Sid's Slime Lounge", handle: '@sticky_sid', poster: 'Films your teeth in bacteria while you sleep.' },
    tess: { name: 'Tartar Tess', short: 'Tess', color: '#D9A441', freq: '94.3', show: "Tess's Quarry", handle: '@tartar_tess', poster: "Hardens into cement your brush can't budge." },
    carl: { name: 'Coffee-Stain Carl', short: 'Carl', color: '#E07A46', freq: '99.9', show: "Carl's All-Night Coffee Bar", handle: '@coffee_stain_carl', poster: 'Dulls your smile brown, yellow, and tired.' },
    gerry: { name: 'Gerry Gingivitis', short: 'Gerry', color: '#FF3B5C', freq: '104.7', show: "Gerry's Gumline Club", handle: '@gerry_gingivitis', poster: 'Bleeds your gums, then pulls them back for good.' }
  };
  var VORDER = ['sid', 'tess', 'carl', 'gerry'];

  /* ---------------- events ---------------- */
  var bus = {};
  function on(e, f) { (bus[e] = bus[e] || []).push(f); }
  function emit(e, d) { (bus[e] || []).forEach(function (f) { try { f(d); } catch (err) { console.error('[nsfm]', err); } }); }

  /* ---------------- memory ---------------- */
  var KEY = 'nsfm_v1', MEM = {};
  try { MEM = JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { MEM = {}; }
  MEM.found = MEM.found || []; MEM.claimed = MEM.claimed || []; MEM.decoded = MEM.decoded || [];
  var lastVisit = MEM.last || 0;
  MEM.visits = (MEM.visits || 0) + 1; MEM.last = Date.now();
  var saveT;
  function save() { clearTimeout(saveT); saveT = setTimeout(function () { try { localStorage.setItem(KEY, JSON.stringify(MEM)); } catch (e) {} }, 120); }
  save();

  /* ---------------- money ---------------- */
  function money(c) {
    var v = Math.round(c || 0) / 100, fmt = D.moneyFormat || '${{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return Math.round(v).toLocaleString('en-US');
      if (k === 'amount_with_comma_separator') return v.toFixed(2).replace('.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return Math.round(v).toLocaleString('de-DE');
      return v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
  }
  function moneyShort(c) { return money(c).replace(/[.,]00(?!\d)/, ''); }

  /* ---------------- feedback: captions, haptics, toasts, analytics ---------------- */
  var S = { mode: 'off', haptic: false, act: 0, clock: 0 };
  var capEl = $('[data-nsfm-caption]'), capT;
  function caption(t) {
    if (!capEl || S.mode === 'off') return;
    capEl.textContent = t; capEl.classList.add('is-on');
    clearTimeout(capT); capT = setTimeout(function () { capEl.classList.remove('is-on'); }, 2600);
  }
  function buzz(p) { if (S.haptic && navigator.vibrate) { try { navigator.vibrate(p); } catch (e) {} } }
  var toastEl;
  function toast(html, ms) {
    if (toastEl) toastEl.remove();
    toastEl = document.createElement('div'); toastEl.className = 'nsfm-toast'; toastEl.setAttribute('role', 'status');
    toastEl.innerHTML = html; root.appendChild(toastEl);
    var el = toastEl; setTimeout(function () { if (el.parentNode) el.remove(); }, ms || 4200);
    return el;
  }
  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('nsfm_' + name, data || {}); } catch (e) {}
  }

  /* ---------------- signal strength (discoveries) ---------------- */
  var SIG_MAX = 14;
  function signalPct() { return Math.min(100, Math.round(MEM.found.length / SIG_MAX * 100)); }
  function renderSignal() {
    var n = Math.ceil(signalPct() / 20);
    $$('.nsfm-hud__sig i').forEach(function (i, k) { i.classList.toggle('is-on', k < n); });
  }
  function discover(key) {
    if (MEM.found.indexOf(key) > -1) return false;
    MEM.found.push(key); save(); renderSignal(); emit('found', key); return true;
  }
  renderSignal();

  /* =========================== SOUND =========================== */
  var Snd = (function () {
    var ctx, master, dry, wet, radioF, music, send, noiseBuf, stGain, timer = null, step = 0, nextT = 0, prog = 'off', layers = {}, tempo = 96, enabled = false;
    function init() {
      if (ctx) return true;
      var AC = window.AudioContext || window.webkitAudioContext; if (!AC) return false;
      ctx = new AC();
      var comp = ctx.createDynamicsCompressor(); comp.threshold.value = -16; comp.ratio.value = 4; comp.connect(ctx.destination);
      master = ctx.createGain(); master.gain.value = 0; master.connect(comp);
      music = ctx.createGain(); music.gain.value = 0.6;
      dry = ctx.createGain(); wet = ctx.createGain(); dry.gain.value = 1; wet.gain.value = 0;
      radioF = ctx.createBiquadFilter(); radioF.type = 'bandpass'; radioF.frequency.value = 1300; radioF.Q.value = 0.45;
      var shaper = ctx.createWaveShaper(); var curve = new Float32Array(256);
      for (var i = 0; i < 256; i++) { var x = i / 128 - 1; curve[i] = Math.tanh(x * 2.2); }
      shaper.curve = curve;
      music.connect(dry); dry.connect(master);
      music.connect(radioF); radioF.connect(shaper); shaper.connect(wet); wet.connect(master);
      var delay = ctx.createDelay(1); delay.delayTime.value = 60 / tempo * 0.75;
      var fb = ctx.createGain(); fb.gain.value = 0.32; send = ctx.createGain(); send.gain.value = 1;
      var dwet = ctx.createGain(); dwet.gain.value = 0.28;
      send.connect(music); send.connect(delay); delay.connect(fb); fb.connect(delay); delay.connect(dwet); dwet.connect(music);
      noiseBuf = ctx.createBuffer(1, ctx.sampleRate * 2, ctx.sampleRate);
      var d = noiseBuf.getChannelData(0); for (var j = 0; j < d.length; j++) d[j] = Math.random() * 2 - 1;
      var st = ctx.createBufferSource(); st.buffer = noiseBuf; st.loop = true;
      var sbp = ctx.createBiquadFilter(); sbp.type = 'bandpass'; sbp.frequency.value = 2600; sbp.Q.value = 0.6;
      stGain = ctx.createGain(); stGain.gain.value = 0;
      st.connect(sbp); sbp.connect(stGain); stGain.connect(master); st.start();
      return true;
    }
    var mtof = function (m) { return 440 * Math.pow(2, (m - 69) / 12); };
    function osc(type, f, t, dur, vol, dest, o) {
      o = o || {};
      var n = ctx.createOscillator(), g = ctx.createGain(), a = o.a || 0.005;
      n.type = type; n.frequency.setValueAtTime(f, t);
      if (o.to) n.frequency.exponentialRampToValueAtTime(o.to, t + (o.tt || dur));
      if (o.detune) n.detune.value = o.detune;
      g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(vol, t + a);
      g.gain.exponentialRampToValueAtTime(0.0001, t + Math.max(dur, a + 0.02));
      var node = n;
      if (o.lp) { var lp = ctx.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.setValueAtTime(o.lp, t); if (o.lpTo) lp.frequency.exponentialRampToValueAtTime(o.lpTo, t + dur); n.connect(lp); node = lp; }
      node.connect(g); g.connect(dest || music); n.start(t); n.stop(t + dur + 0.05);
    }
    function noise(t, dur, vol, type, freq, q, dest) {
      var s = ctx.createBufferSource(); s.buffer = noiseBuf;
      var f = ctx.createBiquadFilter(); f.type = type || 'highpass'; f.frequency.value = freq || 6000; if (q) f.Q.value = q;
      var g = ctx.createGain(); g.gain.setValueAtTime(vol, t); g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
      s.connect(f); f.connect(g); g.connect(dest || music); s.start(t, Math.random() * 1.5); s.stop(t + dur + 0.02);
    }
    var I = {
      kick: function (t, v) { osc('sine', 150, t, 0.32, v || 0.9, null, { to: 42, tt: 0.14 }); },
      clap: function (t, v) { noise(t, 0.16, v || 0.3, 'bandpass', 1800, 0.8); noise(t + 0.012, 0.12, (v || 0.3) * 0.7, 'bandpass', 2300, 0.8); },
      hat: function (t, v, open) { noise(t, open ? 0.22 : 0.045, v || 0.1, 'highpass', 8000); },
      rim: function (t, v) { osc('triangle', 1700, t, 0.04, v || 0.14); noise(t, 0.025, (v || 0.14) * 0.6, 'bandpass', 3500, 2); },
      bass: function (t, m, d, v) { osc('sawtooth', mtof(m), t, d, v || 0.2, null, { lp: 560, lpTo: 160, a: 0.01 }); osc('sine', mtof(m - 12), t, d, (v || 0.2) * 0.9); },
      sub: function (t, m, d, v) { osc('sine', mtof(m), t, d, v || 0.3, null, { a: 0.02 }); },
      pluck: function (t, m, v) { osc('triangle', mtof(m), t, 0.38, v || 0.1, send, { a: 0.003 }); },
      lead: function (t, m, d, v) { osc('square', mtof(m), t, d, v || 0.06, null, { lp: 2600, lpTo: 1100, a: 0.015 }); osc('square', mtof(m), t, d, (v || 0.06) * 0.5, null, { lp: 2600, lpTo: 1100, a: 0.015, detune: 9 }); },
      keys: function (t, ms, d, v) { ms.forEach(function (m) { osc('sine', mtof(m), t, d, v || 0.07, null, { a: 0.01 }); osc('sine', mtof(m + 12), t, d * 0.35, (v || 0.07) * 0.3); }); },
      pad: function (t, ms, d, v) { ms.forEach(function (m) { osc('sawtooth', mtof(m), t, d, v || 0.025, null, { lp: 950, a: d * 0.35, detune: -8 }); osc('sawtooth', mtof(m), t, d, v || 0.025, null, { lp: 950, a: d * 0.35, detune: 8 }); }); },
      metal: function (t, v) { osc('square', 1240, t, 0.12, v || 0.05, null, { to: 880 }); osc('square', 1873, t, 0.09, (v || 0.05) * 0.7, null, { to: 1300 }); }
    };
    var CH = [[57, 60, 64], [53, 57, 60], [48, 52, 55], [55, 59, 62]], ROOT = [45, 41, 48, 43];
    var CH_SUN = [[53, 57, 60], [48, 52, 55], [55, 59, 62], [57, 60, 64]], ROOT_SUN = [41, 48, 43, 45];
    var MEL = { 0: 76, 3: 74, 6: 72, 8: 69, 10: 72, 12: 74, 14: 76 };
    var MEL2 = { 0: 72, 3: 72, 6: 74, 8: 76, 11: 79, 14: 77 };
    function playStep(s, t) {
      var bar = Math.floor(s / 16) % 4, st = s % 16, beat = 60 / tempo;
      if (prog === 'desk' || prog === 'doc' || prog === 'sun') {
        var sun = prog === 'sun', ch = (sun ? CH_SUN : CH)[bar], rt = (sun ? ROOT_SUN : ROOT)[bar];
        if (st === 0) I.pad(t, ch, beat * 4, layers.pad ? 0.03 : 0.012);
        if (layers.beat) {
          if (st === 0 || st === 8 || (bar === 3 && st === 10)) I.kick(t, 0.8);
          if (st === 4 || st === 12) I.clap(t, 0.24);
          if (st % 2 === 0) I.hat(t, 0.06); if (st === 14) I.hat(t, 0.06, true);
        } else if (st % 4 === 2) I.hat(t, 0.025);
        if (layers.bass && [0, 3, 6, 8, 11, 14].indexOf(st) > -1) I.bass(t, rt + (st === 6 ? 12 : 0), beat * 0.45, 0.16);
        if (layers.lead) { var m = (bar % 2 ? MEL2 : MEL)[st]; if (m) I.lead(t, m - (bar === 3 ? 2 : 0), beat * 0.45, 0.05); }
        if (layers.shimmer && st % 4 === 2) I.pluck(t, ch[(st / 4 | 0) % 3] + 24, 0.06);
        if (layers.arp) I.pluck(t, ch[st % 3] + 12 + (layers.arp2 && st % 2 ? 12 : 0), 0.045);
        if (layers.keys && (st === 0 || st === 7)) I.keys(t, ch, beat * 1.2, 0.05);
        if (sun && st === 0) I.pluck(t, ch[2] + 24, 0.08);
      } else if (prog.indexOf('ch:') === 0) {
        var v = prog.slice(3);
        if (v === 'sid') {
          if (st === 0 || st === 10) I.kick(t, 0.6); if (st === 4 || st === 12) I.rim(t, 0.12);
          if (st === 0 || st === 8) I.bass(t, bar % 2 ? 38 : 41, beat * 1.6, 0.16);
          if (st === 0 && bar % 2 === 0) I.pad(t, [62, 65, 69, 72], beat * 8, 0.02);
          if (st % 4 === 2) I.hat(t, 0.03);
        } else if (v === 'tess') {
          if (st === 0 || st === 6 || st === 8) I.kick(t, 0.7); if (st === 4 || st === 12 || st === 14) I.metal(t, 0.045);
          if (st === 0) I.pad(t, [40, 47], beat * 4, 0.03); if (st % 2) I.hat(t, 0.02);
        } else if (v === 'carl') {
          if ([0, 3, 6, 10, 12].indexOf(st) > -1) I.rim(t, 0.12);
          if (st === 0 || st === 7) I.keys(t, bar % 2 ? [52, 55, 59, 62] : [53, 57, 60, 64], beat * 1.4, 0.05);
          if (st % 4 === 0) I.sub(t, (bar % 2 ? 40 : 41) + (st === 8 ? 7 : 0), beat * 0.9, 0.22);
        } else if (v === 'gerry') {
          if (st % 4 === 0) I.kick(t, 0.9); if (st === 4 || st === 12) I.clap(t, 0.25); I.hat(t, st % 2 ? 0.05 : 0.025);
          if (st % 4 === 2) I.bass(t, 33 + 12, beat * 0.4, 0.18);
          if (st === 0 && bar === 0) I.keys(t, [57, 60, 64], beat * 0.5, 0.06);
        }
      }
    }
    function schedule() { while (nextT < ctx.currentTime + 0.12) { playStep(step, nextT); nextT += 60 / tempo / 4; step = (step + 1) % 64; } }
    function route() {
      if (!ctx) return;
      var radio = prog.indexOf('ch:') === 0, t = ctx.currentTime;
      dry.gain.setTargetAtTime(radio ? 0 : 1, t, 0.08); wet.gain.setTargetAtTime(radio ? 0.9 : 0, t, 0.08);
    }
    var api = {
      get on() { return enabled; },
      enable: function () {
        if (!init()) return;
        enabled = true; if (ctx.state === 'suspended') ctx.resume();
        master.gain.cancelScheduledValues(ctx.currentTime); master.gain.setTargetAtTime(0.85, ctx.currentTime, 0.15);
        if (!timer) { nextT = ctx.currentTime + 0.06; timer = setInterval(schedule, 25); }
        route();
      },
      disable: function () {
        enabled = false; if (!ctx) return;
        master.gain.setTargetAtTime(0, ctx.currentTime, 0.08);
        clearInterval(timer); timer = null;
      },
      program: function (p) { if (p === prog) return; prog = p; route(); },
      layers: function (l) { layers = l || {}; },
      static: function (v) { if (ctx && enabled) stGain.gain.setTargetAtTime(clamp(v, 0, 1) * 0.16, ctx.currentTime, 0.05); },
      sfx: function (name) {
        if (!ctx || !enabled) return;
        var t = ctx.currentTime + 0.01, g = master;
        switch (name) {
          case 'detent': osc('square', 2200, t, 0.018, 0.05, g); break;
          case 'click': osc('triangle', 1400, t, 0.03, 0.12, g); break;
          case 'lock': osc('sine', 90, t, 0.4, 0.5, g, { to: 50 }); [72, 76, 79, 84].forEach(function (m, i) { osc('triangle', mtof(m), t + i * 0.05, 0.9, 0.09, g); }); noise(t, 0.4, 0.15, 'bandpass', 2600, 0.6, g); break;
          case 'zap': osc('sawtooth', 220, t, 0.2, 0.12, g, { to: 1760, lp: 3000 }); noise(t, 0.08, 0.1, 'highpass', 5000, 0, g); break;
          case 'drop': osc('sine', 520, t, 0.12, 0.2, g, { to: 1040 }); osc('sine', 1040, t + 0.08, 0.18, 0.14, g); break;
          case 'pop': noise(t, 0.12, 0.6, 'bandpass', 900, 0.7, g); osc('sine', 320, t, 0.25, 0.6, g, { to: 60 }); break;
          case 'spark': for (var i = 0; i < 4; i++) noise(t + Math.random() * 0.12, 0.03, 0.18, 'highpass', 5000 + Math.random() * 3000, 0, g); break;
          case 'thud': osc('sine', 110, t, 0.35, 0.6, g, { to: 38 }); noise(t, 0.08, 0.2, 'lowpass', 400, 0, g); break;
          case 'boing': osc('sine', 300, t, 0.25, 0.16, g, { to: 900, tt: 0.12 }); break;
          case 'flip': noise(t, 0.12, 0.16, 'bandpass', 1500, 1.2, g); break;
          case 'alarm': osc('square', 853, t, 1.6, 0.035, g, { a: 0.02 }); osc('square', 960, t, 1.6, 0.035, g, { a: 0.02 }); break;
          case 'jingle': [76, 79, 81, 84].forEach(function (m, i) { osc('square', mtof(m), t + i * 0.16, 0.3, 0.05, g, { lp: 3200 }); osc('triangle', mtof(m), t + i * 0.16, 0.6, 0.08, g); }); [53, 57, 60, 64].forEach(function (m) { osc('sawtooth', mtof(m), t + 0.5, 1.6, 0.02, g, { lp: 1200, a: 0.3 }); }); break;
          case 'swell': [48, 55, 60, 64, 67].forEach(function (m) { osc('sawtooth', mtof(m), t, 3.2, 0.025, g, { lp: 1800, a: 1.6 }); }); [84, 88, 91].forEach(function (m, i) { osc('sine', mtof(m), t + 1.4 + i * 0.25, 1.4, 0.05, g); }); break;
          case 'tick': osc('square', 3000, t, 0.01, 0.03, g); break;
          case 'cheer': [72, 76, 79, 84, 88].forEach(function (m, i) { osc('triangle', mtof(m), t + i * 0.06, 0.4, 0.08, g); }); break;
        }
      }
    };
    return api;
  })();

  function setSoundMode(m) {
    S.mode = m; root.dataset.sound = m; MEM.soundPref = m; save();
    S.haptic = (m === 'on' || m === 'subs') && !!navigator.vibrate;
    var b = $('[data-nsfm-soundbtn]'); if (b) { b.setAttribute('aria-pressed', String(m === 'on')); b.setAttribute('aria-label', m === 'on' ? 'Sound on. Tap to mute the broadcast' : 'Sound off. Tap for the full broadcast'); }
    if (m === 'on') { Snd.enable(); discover('sound'); caption('♪ radio on'); syncProgram(); track('sound_on'); }
    else Snd.disable();
  }
  function syncProgram() {
    var a = S.act, p = 'off';
    if (a === 0) p = 'tune';
    else if (a === 1) p = 'ch:' + (NS.channel || 'sid');
    else if (a === 2 || a === 3) p = root.classList.contains('is-docon') ? 'doc' : 'ch:' + (NS.channel || 'sid');
    else if (a >= 4 && a <= 8) p = 'desk';
    else if (a === 9) p = 'sun';
    Snd.program(p);
    if (a !== 0) Snd.static(0);
  }

  /* =========================== WORLD =========================== */
  var worldQ = [];
  function whenWorld(fn) { if (NS.world) fn(NS.world); else worldQ.push(fn); }
  function loadWorld() {
    if (loadWorld.started) return; loadWorld.started = true;
    if (!D.assets || !D.assets.world || /nsfm-noworld/.test(location.search)) return;
    try { var c = document.createElement('canvas'); if (!(c.getContext('webgl2') || c.getContext('webgl'))) return; } catch (e) { return; }
    // Load the ES module through an inline module script (theme JS is served as a classic script,
    // and dynamic import() inside it gets rewritten by the CDN's transform).
    new Promise(function (res, rej) {
      window.__nsfmCW = function (cw) { res({ createWorld: cw }); };
      var sc = document.createElement('script'); sc.type = 'module';
      sc.textContent = 'import { createWorld } from ' + JSON.stringify(D.assets.world) + '; window.__nsfmCW(createWorld);';
      document.head.appendChild(sc); setTimeout(function () { rej(new Error('world timeout')); }, 30000);
    }).then(function (m) {
      var w = m.createWorld($('.nsfm-world'), { lite: LITE, reduced: RM });
      NS.world = w; root.classList.add('is-world'); w.jump(S.clock);
      if (root.classList.contains('is-docon')) w.setMood('doc', 1);
      worldQ.splice(0).forEach(function (fn) { try { fn(w); } catch (e) { console.error(e); } });
      emit('world', w);
    }).catch(function (e) { console.warn('[nsfm] world unavailable', e); });
  }

  /* =========================== CLOCK / ACTS =========================== */
  var acts = $$('.nsfm-act');
  // act ids (data-act) drive the world palette and jumps, so an act can be switched off without renumbering
  var ACTN = acts.map(function (a, i) { var n = parseInt(a.dataset.act, 10); return isNaN(n) ? i : n; });
  var toMin = function (s) { var p = (s || '0:0').split(':'); var m = (+p[0]) * 60 + (+p[1]); return m < 12 * 60 ? m + 1440 : m; };
  var TIMES = acts.map(function (a) { return toMin(a.dataset.time); });
  var hudClock = $('[data-nsfm-hudclock]'), hudFreq = $('[data-nsfm-hudfreq]'), footH = 0;
  /* the theme footer slides over the bottom of the world, so the city glows through it (homepage only) */
  (function seeFooter() {
    var main = root.closest('main') || document.getElementById('MainContent');
    function fit() {
      var fs = Array.prototype.slice.call(document.querySelectorAll('.shopify-section-group-footer-group')).filter(function (el) { return el.offsetHeight > 0; });
      if (!fs.length || !main) return;
      fs.forEach(function (el, i) { el.classList.toggle('nsfm-foot-first', i === 0); });
      var h = fs.reduce(function (a, el) { return a + el.offsetHeight; }, 0);
      if (Math.abs(h - footH) < 2) return;
      footH = h; document.documentElement.style.setProperty('--nsfm-foot', h + 'px'); document.body.classList.add('nsfm-seefoot');
    }
    fit(); window.addEventListener('load', fit); window.addEventListener('resize', fit);
    if (window.ResizeObserver) { var ro = new ResizeObserver(fit); document.querySelectorAll('.shopify-section-group-footer-group').forEach(function (el) { ro.observe(el); }); }
  })();
  var scrollFns = [];
  function onScroll(fn) { scrollFns.push(fn); }
  var ticking = false;
  function measure() {
    ticking = false;
    var vh = window.innerHeight, mid = vh * 0.5, clock = 0, idx = 0, frac = 0;
    for (var i = 0; i < acts.length; i++) {
      var r = acts[i].getBoundingClientRect();
      if (r.top <= mid) { idx = i; frac = clamp((mid - r.top) / Math.max(1, r.height), 0, 1); clock = i + frac; }
    }
    var act = ACTN[idx], nextN = idx + 1 < ACTN.length ? ACTN[idx + 1] : act + 1, world = act + frac * (nextN - act);
    S.clock = world;
    if (act !== S.act) {
      S.act = act; root.dataset.act = act; emit('act', act); syncProgram(); track('act', { act: act });
      var nowEl = $('[data-nsfm-hudnow]'); if (nowEl && acts[idx]) nowEl.textContent = acts[idx].dataset.name || '';
    }
    if (NS.world) NS.world.setClock(world);
    var i0 = Math.min(Math.floor(clock), TIMES.length - 1), f = clock - i0, t0 = TIMES[i0] || TIMES[0], t1 = TIMES[Math.min(i0 + 1, TIMES.length - 1)] || t0;
    root.classList.toggle('is-past', root.getBoundingClientRect().bottom - footH < vh - 30);
    var m = Math.round(t0 + (t1 - t0) * f) % 1440;
    if (hudClock) hudClock.textContent = pad2(Math.floor(m / 60)) + ':' + pad2(m % 60);
    scrollFns.forEach(function (fn) { fn(vh); });
  }
  function req() { if (!ticking) { ticking = true; requestAnimationFrame(measure); } }
  window.addEventListener('scroll', req, { passive: true });
  window.addEventListener('resize', req);

  // console visibility + world pause when the section is off screen
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        root.classList.toggle('is-in', e.isIntersecting);
        if (NS.world) { if (e.isIntersecting && !document.hidden) NS.world.resume(); else NS.world.pause(); }
      });
    }, { rootMargin: '-60px 0px -120px 0px' }).observe(root);
  } else root.classList.add('is-in');
  document.addEventListener('visibilitychange', function () { if (!NS.world) return; if (document.hidden) NS.world.pause(); else NS.world.resume(); });

  function jump(i) {
    var k = ACTN.indexOf(i);
    if (k < 0) { for (k = 0; k < ACTN.length && ACTN[k] < i; k++); k = clamp(k, 0, acts.length - 1); }
    var el = acts[k]; if (!el) return;
    NS.skipping = i > 2 ? Date.now() : 0;
    var y = el.getBoundingClientRect().top + window.scrollY - (i === 0 ? 0 : 8);
    window.scrollTo({ top: y, behavior: RM ? 'auto' : 'smooth' });
  }
  root.addEventListener('click', function (e) {
    var j = e.target.closest('[data-nsfm-jump]'); if (!j) return;
    e.preventDefault(); var to = +j.dataset.nsfmJump;
    if (to >= 1) emit('skipping', to);
    jump(to);
  });

  /* =========================== NS (shared) =========================== */
  var NS = window.NSFM = {
    D: D, root: root, $: $, $$: $$, on: on, emit: emit, MEM: MEM, save: save, money: money, moneyShort: moneyShort,
    caption: caption, buzz: buzz, toast: toast, track: track, discover: discover, signalPct: signalPct, Snd: Snd,
    whenWorld: whenWorld, onScroll: onScroll, jump: jump, VILLAINS: VILLAINS, VORDER: VORDER, clamp: clamp, rnd: rnd, deck: deck,
    RM: RM, PHONE: PHONE, COARSE: COARSE, LITE: LITE, S: S, world: null, channel: 'sid', setSoundMode: setSoundMode
  };

  /* touch screens have no arrow keys */
  if (COARSE) { var bh = $('.nsfm-band__hint'); if (bh && /arrow keys/i.test(bh.textContent)) bh.textContent = 'Drag the needle, or just scroll.'; }
  /* sound button */
  var sb = $('[data-nsfm-soundbtn]');
  if (sb) sb.addEventListener('click', function () { setSoundMode(S.mode === 'on' ? 'subs' : 'on'); });
  /* on small screens the pill speaks up at each new act, then tucks itself into a small eq button */
  if (sb) (function () {
    var t = 0, mq = window.matchMedia('(max-width: 1179px)');
    function wake(ms) { sb.classList.remove('is-mini'); clearTimeout(t); t = setTimeout(function () { if (mq.matches) sb.classList.add('is-mini'); }, ms); }
    on('act', function (a) { if (S.mode !== 'on' && a <= 2) wake(4500); });
    sb.addEventListener('click', function () { wake(S.mode === 'on' ? 1800 : 4500); });
    wake(7000);
  })();

  /* pools (chat lines etc.) */
  function loadPools(cb) {
    if (window.NSFM_POOLS) return cb && cb(window.NSFM_POOLS);
    if (cb) on('pools', cb);
    if (loadPools.started) return; loadPools.started = true;
    var s = document.createElement('script'); s.src = D.assets.pools; s.async = true;
    s.onload = function () { emit('pools', window.NSFM_POOLS || {}); };
    document.head.appendChild(s);
  }
  NS.loadPools = loadPools;

  /* =========================== ACT 0 · TUNE IN =========================== */
  (function tune() {
    var sec = $('#tune'), band = $('[data-nsfm-band]'); if (!sec || !band) return;
    var glass = $('.nsfm-band__glass', band), needle = $('.nsfm-band__needle', band), out = $('[data-nsfm-freq]'), sig = $('[data-nsfm-sig]');
    var ghostsEl = $('.nsfm-band__ghosts', band), TARGET = 102.7, SECRET = 107.7;
    var F = 88.6, locked = false, user = false, lastDet = Math.round(F * 2);
    var GH = [[88.1, '…just tonight…'], [90.6, '…floss tomorrow…'], [94.3, '…let it set…'], [97.1, '…one more coffee…'], [99.9, '…stay beige…'], [104.7, '…skip the gumline…'], [106.2, '…rinse is enough…']];
    var ghosts = GH.map(function (g) { var s = document.createElement('span'); s.className = 'nsfm-ghost'; s.textContent = g[1]; s.style.left = ((g[0] - 88) / 20 * 100) + '%'; ghostsEl.appendChild(s); return { f: g[0], el: s }; });
    function setF(f) {
      F = clamp(f, 88, 108);
      needle.style.setProperty('--n', ((F - 88) / 20 * 100).toFixed(2));
      out.textContent = F.toFixed(1);
      needle.setAttribute('aria-valuenow', F.toFixed(1));
      var d = Math.abs(F - TARGET);
      if (!locked) {
        sig.textContent = d < 0.4 ? 'locking…' : d < 2 ? 'faint signal' : 'static';
        needle.setAttribute('aria-valuetext', F.toFixed(1) + ' FM, ' + sig.textContent);
        Snd.static(0.2 + clamp(d / 5, 0, 1) * 0.8);
      }
      ghosts.forEach(function (g) { g.el.style.opacity = clamp(1 - Math.abs(F - g.f) / 1.6, 0, 1) * (locked ? 0.25 : 0.95); });
      var det = Math.round(F * 2); if (det !== lastDet) { lastDet = det; Snd.sfx('detent'); }
      if (!locked && d < 0.16) lock();
      if (user && Math.abs(F - SECRET) < 0.12) secret();
    }
    function lock(quiet) {
      if (locked) return; locked = true; F = TARGET;
      needle.style.setProperty('--n', ((TARGET - 88) / 20 * 100).toFixed(2)); out.textContent = TARGET.toFixed(1);
      root.classList.add('is-locked'); band.classList.add('is-locked'); sig.textContent = 'Diamond Teeth Radio';
      needle.setAttribute('aria-valuetext', '102.7 FM, Diamond Teeth Radio, signal locked');
      if (!quiet) { band.classList.remove('is-bloom'); void band.offsetWidth; band.classList.add('is-bloom'); Snd.sfx('lock'); buzz([14, 40, 30]); caption('📻 signal locks on 102.7 · Diamond Teeth Radio'); if (NS.world) NS.world.flash('#ff3bd4'); }
      Snd.static(0); discover('tuned'); track('tuned_in');
      if (hudFreq) hudFreq.textContent = '102.7 FM';
    }
    var secretDone = false;
    function secret() {
      if (secretDone) return; secretDone = true; discover('secret'); Snd.sfx('jingle');
      toast('📻 <b>107.7 · Doc’s late-night show.</b> “Up this late? Me too. Brush, then bed, kid.”', 5200);
    }
    NS.lockTune = lock;
    function fromX(x) { var r = glass.getBoundingClientRect(); return 88 + clamp((x - r.left - 22) / (r.width - 44), 0, 1) * 20; }
    var dragging = false;
    glass.addEventListener('pointerdown', function (e) { dragging = true; user = true; glass.setPointerCapture(e.pointerId); if (locked && Math.abs(fromX(e.clientX) - TARGET) > 0.3) { /* allow re-tuning for the secret */ } setF(fromX(e.clientX)); });
    glass.addEventListener('pointermove', function (e) { if (dragging) setF(fromX(e.clientX)); });
    glass.addEventListener('pointerup', function () { dragging = false; });
    glass.addEventListener('pointercancel', function () { dragging = false; });
    needle.addEventListener('keydown', function (e) {
      var k = e.key, st = e.shiftKey ? 1 : 0.1;
      if (k === 'ArrowRight' || k === 'ArrowUp') { user = true; setF(F + st); e.preventDefault(); }
      else if (k === 'ArrowLeft' || k === 'ArrowDown') { user = true; setF(F - st); e.preventDefault(); }
      else if (k === 'Home') { setF(88); e.preventDefault(); } else if (k === 'End') { setF(108); e.preventDefault(); }
      else if (k === 'Enter') { lock(); }
    });
    onScroll(function (vh) {
      if (locked || user) return;
      var r = sec.getBoundingClientRect(), p = clamp(-r.top / Math.max(1, r.height - vh), 0, 1);
      if (p <= 0) return;
      setF(88.6 + (TARGET - 88.6) * smoothstep(p / 0.45));
    });
    on('skipping', function () { lock(true); });
    // clock line from the visitor's real time
    var l1 = $('[data-nsfm-clockline]'), l2 = $('[data-nsfm-clocksub]');
    function lines() {
      var d = new Date(), h = d.getHours(), t = pad2(h) + ':' + pad2(d.getMinutes());
      l1.textContent = 'It’s ' + t + '.';
      l2.textContent = (h >= 21 || h < 5) ? 'You skipped brushing.' : (h < 11 ? 'They partied all night.' : 'They’re replaying last night’s show.');
    }
    if (l1 && l2) { lines(); setInterval(lines, 20000); }
    $$('[data-nsfm-sound-choice]').forEach(function (b) {
      b.addEventListener('click', function () {
        setSoundMode(b.dataset.nsfmSoundChoice);
        if (b.dataset.nsfmSoundChoice === 'subs') caption('💬 subtitles on · sound stays off');
        setTimeout(function () { jump(1); }, RM ? 0 : 500);
      });
    });
  })();

  /* =========================== ACT 1 · LIVE RADIO =========================== */
  (function radio() {
    var tv = $('[data-nsfm-tv]'); if (!tv) return;
    var sec = $('#radio'), chat = $('[data-nsfm-chat]'), bubble = $('[data-nsfm-bubble]'), watchEl = $('[data-nsfm-watch]'), showEl = $('[data-nsfm-show]');
    var posterName = $('[data-nsfm-poster-name]'), posterLine = $('[data-nsfm-poster-line]'), logEl = $('[data-nsfm-log]'), claimBtn = $('[data-nsfm-claim]'), heckleBtn = $('[data-nsfm-heckle]');
    var knob = $('.nsfm-dial__knob'), chs = $$('[data-ch]'), villainBox = $('[data-nsfm-villain]');
    var base = { sid: 8412, tess: 6120, carl: 4880, gerry: 9330 }, watch = { sid: 8412, tess: 6120, carl: 4880, gerry: 9330 };
    var cur = 'sid', seen = {}, P = null, decks = {}, live = false, view = null, timers = [];
    var PANIC = ['🪥 WHO SENT THAT', 'brush detected. repeat, BRUSH DETECTED', 'everyone act natural 😬', 'is that… a Sonic?? 😰', 'i’m logging off, this is a raid', 'SOMEONE CLOSE THE GUMLINE', 'not the two-minute timer 😭', 'we were SO comfy'];
    var panicD = deck(PANIC);
    function now() { var d = new Date(); return pad2(d.getHours()) + ':' + pad2(d.getMinutes()); }
    function log(t, you) { var li = document.createElement('li'); li.textContent = t; if (you) li.className = 'is-you'; logEl.insertBefore(li, logEl.firstChild); while (logEl.children.length > 6) logEl.lastChild.remove(); }
    ['02:30 · coffee inbound', '00:30 · still no floss', '00:12 · colony expanding', '23:51 · sugar detected', '23:47 · brush skipped'].forEach(function (t) { log(t); });
    function fmtWatch() { /* fake viewer counter removed */ }
    function addChat(text, handle, panic) {
      var li = document.createElement('li'); if (panic) li.className = 'is-panic';
      var b = document.createElement('b'); b.textContent = handle; li.appendChild(b); li.appendChild(document.createTextNode(text));
      chat.appendChild(li); while (chat.children.length > 7) chat.firstChild.remove();
    }
    function line(v) {
      if (!P) return;
      var k = v || cur;
      if (!decks[k]) decks[k] = { c: deck((P.BYV && P.BYV[k] || []).concat(P.SHARED || [])), h: deck(P[k.toUpperCase() + '_HANDLES'] || P.HANDLES || ['@listener']), s: deck(P.SAYINGS && P.SAYINGS[k] || []) };
      addChat(decks[k].c(), decks[k].h());
    }
    function say() {
      if (!P || !decks[cur]) return;
      var t = decks[cur].s(); if (!t) return;
      bubble.textContent = t; bubble.classList.add('is-on');
      setTimeout(function () { bubble.classList.remove('is-on'); }, 2600);
    }
    function loop() {
      timers.forEach(clearTimeout); timers = [];
      if (!live) return;
      (function c() { line(); timers.push(setTimeout(c, 1500 + Math.random() * 1300)); })();
      (function b() { timers.push(setTimeout(function () { say(); b(); }, 4800 + Math.random() * 2400)); })();
    }
    function mountView(v) {
      whenWorld(function (w) {
        if (view) { view.dispose(); view = null; villainBox.classList.remove('is-3d'); }
        if (!D.models || !D.models[v]) return;
        view = w.view(villainBox, { url: D.models[v], thick: 2.4, swing: 0.6, fit: 1.75, hud: parseInt(VILLAINS[v].color.slice(1), 16), env: 0.6 });
      });
    }
    function setChannel(v, user) {
      if (!VILLAINS[v]) return;
      var first = !seen[v];
      cur = v; NS.channel = v;
      chs.forEach(function (b) { b.setAttribute('aria-checked', String(b.dataset.ch === v)); b.tabIndex = b.dataset.ch === v ? 0 : -1; });
      if (knob) knob.style.setProperty('--rot', (-60 + VORDER.indexOf(v) * 40) + 'deg');
      tv.classList.add('is-switching'); Snd.static(0.9); if (user) { Snd.sfx('click'); buzz(10); }
      setTimeout(function () {
        tv.dataset.channel = v; tv.classList.remove('is-switching'); Snd.static(0);
        if (!RM) { tv.classList.remove('is-on'); void tv.offsetWidth; tv.classList.add('is-on'); }
        showEl.textContent = VILLAINS[v].name + ' · ' + VILLAINS[v].show.replace(/^.*?'s /, '');
        fmtWatch(); claimBtn.setAttribute('aria-pressed', String(MEM.claimed.indexOf(v) > -1));
        claimBtn.style.setProperty('--vc', VILLAINS[v].color);
        chat.innerHTML = ''; for (var i = 0; i < 4; i++) line(v);
        if (first) {
          seen[v] = 1; posterName.textContent = VILLAINS[v].name; posterLine.textContent = VILLAINS[v].poster;
          tv.classList.add('is-poster'); setTimeout(function () { tv.classList.remove('is-poster'); }, RM ? 900 : 1500);
          if (user) discover('ch-' + v);
        }
        mountView(v);
        if (NS.world) NS.world.setChannel(VILLAINS[v].color);
        syncProgram(); caption('📻 ' + VILLAINS[v].freq + ' · ' + VILLAINS[v].show);
      }, RM ? 0 : 260);
    }
    chs.forEach(function (b, i) {
      b.addEventListener('click', function () { setChannel(b.dataset.ch, true); });
      b.addEventListener('keydown', function (e) {
        var d = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
        if (!d) return; e.preventDefault(); var n = chs[(i + d + chs.length) % chs.length]; n.focus(); setChannel(n.dataset.ch, true);
      });
    });
    // swipe the screen to change channel
    var sx = null, sy = null, screen = $('.nsfm-tv__screen', tv);
    screen.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; });
    screen.addEventListener('pointerup', function (e) {
      if (sx == null) return; var dx = e.clientX - sx, dy = e.clientY - sy; sx = null;
      if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.4 && !e.target.closest('[data-nsfm-villain]')) {
        var i = VORDER.indexOf(cur) + (dx < 0 ? 1 : -1); setChannel(VORDER[(i + 4) % 4], true);
      }
    });
    heckleBtn.addEventListener('click', function () {
      if (view) view.flinch(); villainBox.classList.remove('is-flinch'); void villainBox.offsetWidth; villainBox.classList.add('is-flinch');
      for (var i = 0; i < 3; i++) setTimeout(function () { addChat(panicD(), '@' + cur + '_crew', true); }, i * 260);
      watch[cur] = Math.max(Math.round(base[cur] * 0.35), watch[cur] - (300 + Math.floor(Math.random() * 700))); fmtWatch();
      Snd.sfx('boing'); buzz([18, 30, 18]); caption('🪥 a brush flies across the set'); discover('heckle'); track('heckle', { villain: cur });
      bubble.textContent = rnd(['HEY! Who let a brush in?!', 'Not on my show!', 'Security!! SECURITY!!', 'I felt that in my biofilm.']); bubble.classList.add('is-on');
      setTimeout(function () { bubble.classList.remove('is-on'); }, 2200);
    });
    function syncClaimed() {
      chs.forEach(function (b) { b.classList.toggle('is-claimed', MEM.claimed.indexOf(b.dataset.ch) > -1); });
      claimBtn.setAttribute('aria-pressed', String(MEM.claimed.indexOf(cur) > -1));
    }
    claimBtn.addEventListener('click', function () {
      var i = MEM.claimed.indexOf(cur);
      if (i > -1) { MEM.claimed.splice(i, 1); log(now() + ' · listener left ' + VILLAINS[cur].short + '’s show', true); }
      else { MEM.claimed.push(cur); log(now() + ' · new listener: you (' + VILLAINS[cur].short + ')', true); Snd.sfx('cheer'); buzz(20); caption('✋ you claimed ' + VILLAINS[cur].name); track('villain_claimed', { villain: cur }); }
      save(); syncClaimed(); discover('claim'); emit('claimed', MEM.claimed.slice());
    });
    syncClaimed();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          live = e.isIntersecting;
          if (live) { loadPools(function (p) { P = p; if (!chat.children.length) { for (var i = 0; i < 4; i++) line(); } loop(); }); if (!seen[cur]) setChannel(cur, false); }
          else loop();
        });
      }, { rootMargin: '0px 0px -10% 0px' }).observe(sec);
    }
    on('act', function (a) { if (a !== 1 && NS.world && a > 2) NS.world.setChannel(null); });
  })();

  /* =========================== ACT 2 · DOC =========================== */
  (function doc() {
    var sec = $('#doc'); if (!sec) return;
    var ebs = $('.nsfm-ebs'), fired = false;
    if (ebs) root.appendChild(ebs); // lift above the theme header
    function fire() {
      if (fired) return;
      if (NS.skipping && Date.now() - NS.skipping < 2500) return; // flying past on a shortcut: no alarm
      fired = true;
      if (!RM) { ebs.classList.add('is-on'); setTimeout(function () { ebs.classList.remove('is-on'); }, 2300); }
      Snd.sfx('alarm'); caption('⚠ emergency broadcast tone'); buzz([60, 40, 60]);
      if (NS.world) NS.world.flash('#ff2b4a');
      track('doc_hijack');
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) fire(); }); }, { threshold: 0.12 }).observe(sec);
    }
    var docBox = $('[data-nsfm-doc]'), docView = null, quoteEl = $('[data-nsfm-doc-quote]');
    whenWorld(function (w) {
      if (!D.models || !D.models.doc) return;
      docView = w.view(docBox, { url: D.models.doc, thick: 2.8, swing: 0.55, fit: 1.95, hud: 0x2be6ff, env: 0.75, fx: 'doc', state: RM ? 'solid' : 'wire' });
      if (!RM) docView.loaded.then(function () { setTimeout(function () { docView.setState('charged'); }, 250); setTimeout(function () { docView.setState('solid'); }, 1100); });
    });
    var PEP = [
      'Two minutes, kid. That’s all the future’s askin’ for.',
      'Sid only wins on the nights you skip. So don’t give him the night.',
      'Brush the gumline like you mean it. Gerry hates commitment.',
      'You don’t need perfect. You need tonight, and tomorrow night.',
      'Every brush is a power cut on their whole broadcast.',
      'Tartar’s just plaque that got comfy. Don’t let it get comfy.',
      'Charge the brush, charge the kid, charge the smile. In that order.'
    ].concat((D.docLines || []).map(function (l) { return String(l).trim(); }).filter(Boolean));
    var pep = deck(PEP), px0 = null;
    function zapDoc() {
      if (docView && docView.zap) docView.zap();
      Snd.sfx('zap'); setTimeout(function () { Snd.sfx('spark'); }, 90); buzz([12, 30, 12]);
      if (quoteEl) { quoteEl.classList.remove('is-new'); void quoteEl.offsetWidth; quoteEl.textContent = '“' + pep() + '”'; quoteEl.classList.add('is-new'); }
      docBox.classList.add('is-tapped'); discover('doc-zap'); track('doc_zap');
    }
    docBox.addEventListener('pointerdown', function (e) { px0 = [e.clientX, e.clientY]; });
    docBox.addEventListener('pointerup', function (e) { if (px0 && Math.abs(e.clientX - px0[0]) < 8 && Math.abs(e.clientY - px0[1]) < 8) zapDoc(); px0 = null; });
    docBox.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); zapDoc(); } });
    // case files: claimed villains first
    var wrap = $('[data-nsfm-cases]'), cases = $$('.nsfm-case', wrap);
    function order() {
      var claimed = MEM.claimed;
      cases.slice().sort(function (a, b) {
        var ia = claimed.indexOf(a.dataset.case), ib = claimed.indexOf(b.dataset.case);
        return (ia < 0 ? 9 + VORDER.indexOf(a.dataset.case) : ia) - (ib < 0 ? 9 + VORDER.indexOf(b.dataset.case) : ib);
      }).forEach(function (c) { wrap.appendChild(c); });
    }
    order(); on('claimed', order);
    function open(c, auto) {
      var o = !c.classList.contains('is-open');
      c.classList.toggle('is-open', o); $('.nsfm-case__flip', c).setAttribute('aria-expanded', String(o));
      if (o) {
        Snd.sfx('flip'); if (!auto) buzz(10);
        if (!c.classList.contains('is-decoded')) {
          setTimeout(function () { c.classList.add('is-decoded'); }, 500);
          if (MEM.decoded.indexOf(c.dataset.case) < 0) { MEM.decoded.push(c.dataset.case); save(); }
          discover('case-' + c.dataset.case);
        }
      }
    }
    cases.forEach(function (c) {
      $('.nsfm-case__flip', c).addEventListener('click', function () { open(c); });
      $('.nsfm-case__back', c).addEventListener('click', function () { open(c); });
      if (MEM.decoded.indexOf(c.dataset.case) > -1) c.classList.add('is-decoded');
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return; io.disconnect();
          MEM.claimed.forEach(function (v, i) { var c = wrap.querySelector('[data-case="' + v + '"]'); if (c && !c.classList.contains('is-open')) setTimeout(function () { open(c, true); }, 500 + i * 420); });
        });
      }, { threshold: 0.4 });
      io.observe(wrap);
    }
    // the chain scrubber
    var chain = $('[data-nsfm-chain]'), range = $('[data-nsfm-chain-range]'), stage = $('[data-nsfm-chain-stage]'), undo = $('[data-nsfm-chain-undo]');
    var ST = [
      ['Tonight · Sticky Sid', 'A soft bacterial film settles in. Brushing and cleaning between teeth remove it.', 'You can still take this back.', 'Tonight'],
      ['1–3 days · Tartar Tess', 'Plaque left alone starts hardening into tartar within 24–72 hours. Brushing won’t shift it now; it needs mechanical removal.', 'Removable, but not by brushing.', 'Days'],
      ['Weeks · Gerry Gingivitis', 'Plaque sitting at the gum margin irritates the gums: red, puffy, bleeding when you brush. The inflammation is reversible.', 'Still reversible.', 'Weeks'],
      ['Months to years', 'Left long enough, it can progress to the kind that takes gum and bone with it.', 'Lost gum and bone don’t grow back. Talk to a dentist.', 'Months to years']
    ];
    var lastSt = -1, wasRed = false;
    function upd() {
      var v = +range.value, p = v / 100, s = v < 20 ? 0 : v < 45 ? 1 : v < 75 ? 2 : 3;
      chain.style.setProperty('--p', p.toFixed(3));
      if (s !== lastSt) {
        lastSt = s; stage.innerHTML = '<b>' + ST[s][0] + '</b> ' + ST[s][1]; undo.textContent = ST[s][2];
        range.setAttribute('aria-valuetext', ST[s][3] + '. ' + ST[s][2]); Snd.sfx('tick');
      }
      var red = v >= 75;
      if (red !== wasRed) {
        wasRed = red; chain.classList.toggle('is-red', red);
        if (red) { Snd.sfx('thud'); buzz(45); caption('⛔ crossed the line you can’t take back'); discover('redline'); }
      }
    }
    if (range) { range.addEventListener('input', upd); upd(); }
    var chair = $('[data-nsfm-chair]');
    if (chair && 'IntersectionObserver' in window) new IntersectionObserver(function (es, o) { es.forEach(function (e) { if (e.isIntersecting) { chair.classList.add('is-in'); o.disconnect(); } }); }, { threshold: 0.5 }).observe(chair);
  })();

  /* =========================== ACT 3 · PULL THE PLUG =========================== */
  (function plug() {
    var sec = $('#plug'), wrap = $('[data-nsfm-plug]'), head = $('[data-nsfm-plughead]'); if (!wrap || !head) return;
    var cables = $$('.nsfm-plug__cable,.nsfm-plug__cable2', wrap), sparks = $('.nsfm-plug__sparks', wrap), socket = $('.nsfm-plug__socket', wrap);
    var done = false, drag = null, hold = 0, holdRaf = 0, sparkT = 0;
    function rest() {
      var w = wrap.getBoundingClientRect(), s = socket.getBoundingClientRect(), h = head.getBoundingClientRect();
      return { x: (s.left - w.left) - h.width * 0.42, y: (s.top - w.top) + s.height * 0.38, w: w.width, h: w.height };
    }
    function place(x, y, rot) {
      var R = rest();
      head.style.setProperty('--px', x + 'px'); head.style.setProperty('--py', y + 'px'); head.style.setProperty('--pr', (rot || 0) + 'deg');
      var vx = (x - head.offsetWidth * 0.45) / R.w * 1000, vy = y / R.h * 260;
      var d = 'M-20 ' + (260 * 0.78) + ' C 220 ' + (260 * 0.8) + ' ' + (vx * 0.55) + ' ' + (vy + 40) + ' ' + vx.toFixed(1) + ' ' + vy.toFixed(1);
      cables.forEach(function (c) { c.setAttribute('d', d); });
    }
    function home(anim) {
      var R = rest(); head.style.transition = anim ? 'left .5s cubic-bezier(.34,1.56,.64,1), top .5s cubic-bezier(.34,1.56,.64,1)' : 'none';
      place(R.x, R.y, 0); wrap.classList.remove('is-tense');
      if (anim) setTimeout(function () { head.style.transition = ''; }, 520);
    }
    function burst(n, x, y, color) {
      if (RM) return;
      sparks.style.setProperty('--sx', x + 'px'); sparks.style.setProperty('--sy', y + 'px');
      for (var i = 0; i < n; i++) {
        var s = document.createElement('i'); s.className = 'nsfm-spark';
        s.style.setProperty('--a', (Math.random() * 360) + 'deg'); s.style.setProperty('--d', (-40 - Math.random() * 90) + 'px');
        if (color) s.style.background = color;
        sparks.appendChild(s); setTimeout(function (el) { el.remove(); }.bind(null, s), 700);
      }
    }
    function tense(t) {
      wrap.classList.toggle('is-tense', t > 0.3);
      var now = performance.now();
      if (t > 0.35 && now - sparkT > 140) { sparkT = now; var R = rest(); burst(3 + Math.floor(t * 6), R.x + head.offsetWidth * 0.4, R.y); Snd.sfx('spark'); buzz(6); }
    }
    function unplug(quiet) {
      if (done) return; done = true;
      cancelAnimationFrame(holdRaf); head.style.setProperty('--hold', 0);
      var R = rest();
      if (!quiet) {
        burst(30, R.x + head.offsetWidth * 0.4, R.y); Snd.sfx('pop'); buzz([30, 60, 90]);
        head.style.transition = 'left .7s cubic-bezier(.2,.9,.25,1), top .7s cubic-bezier(.2,.9,.25,1), transform .7s';
        place(R.x - R.w * 0.42, R.y + 70, -28);
        var crt = $('[data-nsfm-crt]'); if (crt && !RM) { crt.classList.remove('is-on'); void crt.offsetWidth; crt.classList.add('is-on'); }
        Snd.program('off'); caption('🔌 the plug pops · their broadcast collapses');
      } else place(R.x - R.w * 0.3, R.y + 50, -20);
      root.classList.add('is-unplugged'); head.setAttribute('aria-disabled', 'true');
      discover('unplug'); track('plug_pulled', { quiet: !!quiet });
      setTimeout(function () {
        root.classList.add('is-docon'); root.dataset.doc = '1';
        if (NS.world) { NS.world.flash('#4c8bff'); var k = 0; (function up() { k = Math.min(1, k + 0.04); NS.world.setMood('doc', k); if (k < 1) requestAnimationFrame(up); })(); }
        Snd.sfx('jingle'); caption('⚡ Night Shift FM powers up · Doc’s on'); syncProgram();
        emit('docon');
      }, quiet ? 0 : 1900);
    }
    NS.unplug = unplug;
    head.addEventListener('pointerdown', function (e) {
      if (done) return; e.preventDefault(); head.setPointerCapture(e.pointerId);
      var R = rest(); drag = { x0: e.clientX, y0: e.clientY, rx: R.x, ry: R.y, moved: false, t0: performance.now() };
      head.style.transition = 'none';
      // press-and-hold
      cancelAnimationFrame(holdRaf); hold = 0;
      (function h() {
        if (!drag || done) return;
        if (!drag.moved && performance.now() - drag.t0 > 220) {
          hold = Math.min(1, hold + 1 / 66); head.style.setProperty('--hold', hold.toFixed(3)); tense(hold);
          if (hold >= 1) { drag = null; unplug(); return; }
        }
        holdRaf = requestAnimationFrame(h);
      })();
    });
    head.addEventListener('pointermove', function (e) {
      if (!drag || done) return;
      var dx = e.clientX - drag.x0, dy = e.clientY - drag.y0;
      if (Math.abs(dx) + Math.abs(dy) > 6) { drag.moved = true; hold = 0; head.style.setProperty('--hold', 0); }
      var R = rest(), pull = Math.max(0, -dx) + Math.abs(dy) * 0.4, need = R.w * 0.26, t = clamp(pull / need, 0, 1);
      var damp = pull * (0.75 - t * 0.35);
      place(drag.rx - damp, drag.ry + dy * 0.35, -t * 10); tense(t);
      if (t >= 1) { drag = null; unplug(); }
    });
    function release() { if (!drag || done) { drag = null; return; } drag = null; cancelAnimationFrame(holdRaf); hold = 0; head.style.setProperty('--hold', 0); home(true); }
    head.addEventListener('pointerup', release); head.addEventListener('pointercancel', release);
    // keyboard: press and hold Enter/Space
    var kHold = null;
    head.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && !kHold && !done) {
        e.preventDefault(); var k = 0;
        kHold = setInterval(function () { k += 0.05; head.style.setProperty('--hold', k.toFixed(2)); tense(k); if (k >= 1) { clearInterval(kHold); kHold = null; unplug(); } }, 50);
      }
    });
    head.addEventListener('keyup', function () { if (kHold) { clearInterval(kHold); kHold = null; head.style.setProperty('--hold', 0); } });
    home(false); window.addEventListener('resize', function () { if (!done) home(false); });
    on('act', function (a) { if (a >= 4 && !done) unplug(true); });
    on('skipping', function (to) { if (to >= 4 && !done) unplug(true); });
  })();

  /* =========================== easter eggs + return visits =========================== */
  (function extras() {
    var K = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'b', 'a'], ki = 0;
    document.addEventListener('keydown', function (e) {
      ki = (e.key === K[ki] || e.key.toLowerCase() === K[ki]) ? ki + 1 : (e.key === K[0] ? 1 : 0);
      if (ki === K.length) {
        ki = 0; var on8 = !root.classList.contains('is-8bit'); root.classList.toggle('is-8bit', on8);
        if (NS.world) NS.world.pixel(on8); Snd.sfx('cheer'); discover('konami');
        toast(on8 ? '👾 <b>8-bit Mouth City.</b> Same code again to switch back.' : 'Back to full resolution.');
      }
    });
    if (MEM.visits > 1 && lastVisit && Date.now() - lastVisit > 6 * 3600 * 1000) {
      var v = VILLAINS[MEM.claimed[0] || 'sid'], day = new Date(lastVisit).toLocaleDateString('en-US', { weekday: 'long' });
      setTimeout(function () { toast('👋 <b>Welcome back.</b> ' + v.short + '’s been busy since ' + day + '.', 5200); }, 1600);
    }
  })();

  /* Shopify's theme preview bar sits over the bottom of the page: lift the console above it. */
  function previewBar() {
    var f = document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe'), h = 0;
    if (f) { var r = f.getBoundingClientRect(); if (r.height && r.bottom >= innerHeight - 4 && getComputedStyle(f).display !== 'none') h = Math.round(innerHeight - r.top); }
    root.style.setProperty('--pb', Math.max(0, Math.min(h, 90)) + 'px');
  }
  setTimeout(previewBar, 1500); setTimeout(previewBar, 5000); window.addEventListener('resize', previewBar);

  /* kick off */
  measure();
  var startWorld = function () { (window.requestIdleCallback || function (f) { return setTimeout(f, 600); })(loadWorld, { timeout: 2500 }); };
  if (document.readyState === 'complete') startWorld(); else window.addEventListener('load', startWorld);
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es, o) { es.forEach(function (e) { if (e.isIntersecting) { loadPools(); o.disconnect(); } }); }, { rootMargin: '600px 0px' }).observe($('#radio') || root);
  }
  emit('ready');
})();
